import React from 'react'
import ReactMarkdown from 'react-markdown'
import classNames from 'classnames'
import { Section } from '../../../../index'

const ServicesDesign = props => {
  const {
    content: { markdown, images, metadata },
  } = props
  return (
    <Section
      className={classNames('services-design', metadata ? metadata.className : '')}
      innerClassName="intro__wrapper"
      isCentered
    >
      <section className="services-design__images">
        <div className="services-design__left">
          {images.map(({ id, title, sizes }) => (
            <img
              key={id}
              className="services-design__image"
              src={sizes.src}
              srcSet={sizes.srcSet.split('fm=jpg').join('fm=jpg&fl=progressive')}
              sizes="50vw"
              alt={title}
            />
          ))}
        </div>
      </section>
      <section className="services-design__markdown">
        <ReactMarkdown escapeHtml={false} source={markdown.content} />
      </section>
    </Section>
  )
}

export default ServicesDesign
